import PropTypes from 'prop-types';
import { AuthWidthTemplate } from 'src/components';
import { useTranslation } from 'src/hooks';

const CoverExample = ({ id, image, title }) => {
  const { translate } = useTranslation();
  return (
    <div className="templates__item">
      <div className="templates__img">
        <img src={image} alt="template" />
        <AuthWidthTemplate
          to="/my-covers/create/"
          content={translate('cover.choose_this_template')}
          template={id}
        />
      </div>
      <div className="template__des">{title}</div>
    </div>
  );
};

CoverExample.propTypes = {
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CoverExample;
